import React from "react";
import Select from "react-select";

const MultiSelect: React.FC<any> = (props: any) => {
  /** Select all option */
  const selectAllOption = {
    value: "<SELECT_ALL>",
    label: "All",
  };

  /** Code to check all items are selected */
  const isSelectAllSelected = () =>
    props.selectedItems?.length === props.options?.length;

  /** Code to check is items are selected */
  const isOptionSelected = (option: any) =>
    props?.selectedItems?.some(({ value }: any) => value === option.value) ||
    isSelectAllSelected();

  /** Code to handle all the event based logics to bind and remove select all */
  const onChange = (newValue: any, actionMeta: any) => {
    const { action, option, removedValue } = actionMeta;

    if (action === "select-option" && option.value === selectAllOption.value) {
      props.setSelectedItems(props?.options);
    } else if (
      (action === "deselect-option" &&
        option.value === selectAllOption.value) ||
      (action === "remove-value" &&
        removedValue.value === selectAllOption.value)
    ) {
      props.setSelectedItems([]);
    } else if (
      actionMeta.action === "deselect-option" &&
      isSelectAllSelected()
    ) {
      props.setSelectedItems(
        props?.options.filter(({ value }: any) => value !== option.value)
      );
    } else if (action === "remove-value" && removedValue.value) {
      let ds: Array<any> = [];
      if (props.selectedItems.length) {
        ds = props.selectedItems.filter(
          ({ value }: any) => value !== removedValue.value
        );
      }
      props.setSelectedItems(ds);
    } else {
      props.setSelectedItems(newValue || []);
    }

    if (props?.onChange) {
      if (
        action === "select-option" &&
        option.value === selectAllOption.value
      ) {
        props.onChange(props?.options, actionMeta);
      } else {
        props.onChange(newValue, actionMeta);
      }
    }
  };

  return (
    <Select
      placeholder=""
      isMulti={true}
      isDisabled={props.isDisabled ?? false}
      options={[selectAllOption, ...props.options]}
      value={props.selectedItems}
      onChange={onChange}
      isOptionSelected={isOptionSelected}
      closeMenuOnSelect={false}
      menuPortalTarget={document.body}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: "#B3B3B3",
          primary: "#041E42",
        },
      })}
      styles={{
        control: (base, state) => ({
          ...base,
          background:
            document.getElementsByClassName("dark")?.length > 0
              ? "#1A1C23"
              : document.getElementsByClassName("disabled")?.length > 0
              ? "bg-gray-100"
              : "white",
          borderColor:
            document.getElementsByClassName("dark")?.length > 0
              ? "#6B7280"
              : "#D1D5DB",
          borderWidth: "1px",
          "&:hover": {
            borderColor:
              state.isFocused &&
              document.getElementsByClassName("dark")?.length > 0
                ? "#6b7280"
                : state.isFocused
                ? "#4c5563"
                : "",
          },
        }),
        singleValue: (base) => ({
          ...base,
          color:
            document.getElementsByClassName("dark")?.length > 0
              ? "white"
              : "#374051",
        }),
        input: (base) => ({
          ...base,
          color:
            document.getElementsByClassName("dark")?.length > 0 ? "white" : "",
        }),
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
    ></Select>
  );
};

export default MultiSelect;
